export default __webpack_public_path__ + "static/media/xmas_2024-bm.accdea42.webp";